import { SettingsSectionsName } from "../settings-sections-name";
import { SystemConfigurationResolveData } from "../system-configuration-resolve-data";

export class PatientSettings {
    monthsUntilReview: number;

    static parse(data: SystemConfigurationResolveData): PatientSettings {
        return data.getConfigSection<PatientSettings>(SettingsSectionsName.PatientSettings);
    }
}